import { UserRequestType } from "../enums/global.enums";

export function requestTypePipe(value: string) {
    switch (value) {
        case UserRequestType.All: return "Tất cả";
        case UserRequestType.Leak: return "Rò rỉ đường ống";
        case UserRequestType.WaterLoss: return "Mất nước";
        case UserRequestType.WaterQuality: return "Chất lượng nước";
        case UserRequestType.Payment: return "Thanh toán";
        case UserRequestType.Meter: return "Đồng hồ nước";
        case UserRequestType.Other: return "Khác";
        default: return "";
    }
}